import React, { useState } from "react";
import DrawerWrapper from "../../../layout/DrawerWrapper";
import FlareIcon from "@material-ui/icons/Flare";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import CropRotateIcon from "@material-ui/icons/CropRotate";
import EcoIcon from "@material-ui/icons/Eco";
import ListItemText from "@material-ui/core/ListItemText";
import { Link } from "react-router-dom";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import SettingsIcon from "@material-ui/icons/Settings";

export const Sidebar = () => {
  const [openPhotovoltaic, setOpenPhotovoltaic] = useState(false);
  const [openWindTurbine, setOpenWindTurbine] = useState(false);
  const [openEnvironmental, setOpenEnvironmental] = useState(false);
  const [openConfigurations, setOpenConfigurations] = useState(false);

  const styleLink = {
    color: "white",
    fontSize: "16px",
    textDecoration: "none",
  };
  const styleListItem = {
    paddingTop: 0,
    paddingBottom: 0,
  };
  const styleListItemIcon = {
    color: "white",
    minWidth: "46px",
    marginLeft: "9px",
  };
  const styleDoubleArrow = { fontSize: "18px", marginLeft: "-9px" };
  const styleArrowRight = { fontSize: "18px", marginLeft: "-9px" };

  const mainList = (
    <React.Fragment>
      {/* PHOTOVOLTAIC */}
      <ListItem
        button
        onClick={() => setOpenPhotovoltaic(!openPhotovoltaic)}
        style={{ paddingBottom: 7 }}
      >
        <ListItemIcon style={{ color: "white" }}>
          <FlareIcon></FlareIcon>
        </ListItemIcon>
        <ListItemText primary={"Photovoltaic"} />
        {openPhotovoltaic ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={openPhotovoltaic}
        timeout="auto"
        unmountOnExit
        style={{ marginLeft: "10px" }}
      >
        <List component="div">
          <Link style={styleLink} to={"/dashboard/maps/fixed_zero"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Fixed at zero"} />
            </ListItem>
          </Link>
          <Link style={styleLink} to={"/dashboard/maps/fixed_optimal"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Fixed optimal"} />
            </ListItem>
          </Link>
          <Link style={styleLink} to={"/dashboard/maps/inclined_optimal"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Inclined optimal"} />
            </ListItem>
          </Link>
          <Link style={styleLink} to={"/dashboard/maps/two_axis"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Two axis"} />
            </ListItem>
          </Link>
        </List>
      </Collapse>
      {/* WIND TURBINE */}
      <ListItem
        button
        onClick={() => setOpenWindTurbine(!openWindTurbine)}
        style={{ paddingBottom: 7 }}
      >
        <ListItemIcon style={{ color: "white" }}>
          <CropRotateIcon />
        </ListItemIcon>
        <ListItemText primary={"Wind Turbine"} />
        {openWindTurbine ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={openWindTurbine}
        timeout="auto"
        unmountOnExit
        style={{ marginLeft: "10px" }}
      >
        <List component="div">
          <Link style={styleLink} to={"/dashboard/maps/wt_model_1"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Best perf."} />
            </ListItem>
          </Link>
          <Link style={styleLink} to={"/dashboard/maps/wt_model_2"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Mean perf."} />
            </ListItem>
          </Link>
          <Link style={styleLink} to={"/dashboard/maps/wt_model_3"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Long life"} />
            </ListItem>
          </Link>
        </List>
      </Collapse>
      {/* ENVIRONMENTAL */}
      <ListItem
        button
        onClick={() => setOpenEnvironmental(!openEnvironmental)}
        style={{ paddingBottom: 7 }}
      >
        <ListItemIcon style={{ color: "white" }}>
          <EcoIcon />
        </ListItemIcon>
        <ListItemText primary={"Environmental"} />
        {openEnvironmental ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={openEnvironmental}
        timeout="auto"
        unmountOnExit
        style={{ marginLeft: "10px" }}
      >
        <List component="div">
          <Link style={styleLink} to={"/dashboard/maps/windspeed"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Windspeed"} />
            </ListItem>
          </Link>
          {/* <Link style={styleLink} to={"/dashboard/maps/emere-gdp"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Emere-GDP"} />
            </ListItem>
          </Link> */}
        </List>
      </Collapse>
    </React.Fragment>
  );

  const secondaryList = (
    <React.Fragment>
      {/* <ListItem
        button
        onClick={() => setOpenConfigurations(!openConfigurations)}
        style={{ paddingBottom: 7 }}
      >
        <ListItemIcon style={{ color: "white" }}>
          <SettingsIcon></SettingsIcon>
        </ListItemIcon>
        <ListItemText primary={"Configurations"} />
        {openConfigurations ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={openConfigurations}
        timeout="auto"
        unmountOnExit
        style={{ marginLeft: "10px" }}
      >
        <List component="div">
          <Link style={styleLink} to={"/dashboard/maps/configurations_map"}>
            <ListItem button style={styleListItem}>
              <ListItemIcon style={styleListItemIcon}>
                <DoubleArrowIcon style={styleDoubleArrow} />
              </ListItemIcon>
              <ListItemText primary={"Map"} />
            </ListItem>
          </Link>
        </List>
      </Collapse> */}
    </React.Fragment>
  );

  return (
    <DrawerWrapper
      mainList={mainList}
      secondaryList={secondaryList}
    ></DrawerWrapper>
  );
};

export default Sidebar;
